import $ from "cash-dom";
import getCssVarValue from "./function_get-css-var-value";

export default (function () {
    var selector = "[data-layout='panorama']";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_panorama.js initialized", "green");

        var delay = getCssVarValue("--duration-lg");
        var $lightbox = $(
            `<div id="lightbox" class="fixed inset global flex justify-start px-global align-center clip bg-none transition-lg scroll-x scroll-y z-4"></div>`,
        );
        var $descriptionBox = $(
            `<div class="description-box copy-xs flex column justify-between sans c-accent fixed bottom-0.5 sm:bottom-1.0 left-0.5 sm:left-1.0 md:left-auto right-0.5 sm:right-1.0 px-0.5 py-0.5 bg-lighten z-1 fade-in transition-sm radius-0.125 md:width-4col" aria-hidden>
                <h3 class="headline copy-lg bold uppercase c-accent mb-0.25 hyphens-manual lh-1"></h3>
                <div class="description scroll-y hyphens-auto scroll-shadows"></div>
                <div class="toolbar flex justify-between align-center mt-0.5">
                    <div class="navigation flex row gx-0.25 no-shrink">
                        <button class="pointer lh-0 aspect-1:1 width-1.5 sm:width-1.0 radius-round c-accent bg-white hover:bg-page" data-prev>
                            <svg class="icon stroke-lg mirror-x" style="aspect-ratio: 1"><use href="#chevron-right"></use></svg>
                            <span class="sr-text">${jdmn_l10n.previous}</span>
                        </button>
                        <button class="pointer lh-0 aspect-1:1 width-1.5 sm:width-1.0 radius-round c-accent bg-white hover:bg-page" data-next>
                            <svg class="icon stroke-lg" style="aspect-ratio: 1"><use href="#chevron-right"></use></svg>
                            <span class="sr-text">${jdmn_l10n.previous}</span>
                        </button>
                    </div>
                    <div class="function flex row gx-0.25 no-shrink">
                        <button class="pointer lh-0 aspect-1:1 width-1.5 sm:width-1.0 radius-round c-accent bg-white hover:bg-page" data-minimize>
                            <svg class="icon stroke-lg fade-in" style="aspect-ratio: 1"><use href="#enlarge"></use></svg>
                            <svg class="icon stroke-lg" style="aspect-ratio: 1"><use href="#shrink"></use></svg>
                            <span class="sr-text">${jdmn_l10n.minimize}</span>
                        </button>
                        <button class="pointer lh-0 aspect-1:1 width-1.5 sm:width-1.0 radius-round c-accent bg-white hover:bg-page enlarge-click" data-close>
                            <svg class="icon stroke-lg" style="aspect-ratio: 1"><use href="#close"></use></svg>
                            <span class="sr-text">${jdmn_l10n.close}</span>
                        </button>
                    </div>
                </div>
            </div>`,
        );
        var $closeButton = $descriptionBox.find("[data-close]");
        var $navButton = $descriptionBox.find(".navigation button");
        var $button = $(selector).find("[data-toggle]");
        var $minimizeButton = $descriptionBox.find("[data-minimize]");
        var $context = $descriptionBox.find(".description, .headline, .navigation, [data-close]");
        var $instance = null;
        var $slides = null;
        var global = getCssVarValue("--space-global");
        var columnSpace = getCssVarValue("--space-column");
        var columnWidth = getCssVarValue("--width-column");
        var isMobile = window.innerWidth < 600;

        var index = 0;
        var max = null;

        function getInitialOffset(_initialRect) {
            var fromLeft = _initialRect.left;
            var fromTop = _initialRect.top;
            var toLeft = (window.innerWidth - _initialRect.width) / 2;
            var toTop = (window.innerHeight - _initialRect.height) / 2;

            return { x: fromLeft - toLeft + "px", y: fromTop - toTop + "px" };
        }

        function closeHandler(_e) {
            index = 0;
            max = null;

            $navButton.off("click");
            $minimizeButton.off("click");
            $closeButton.off("click");
            $lightbox.toggleClass("bg-none bg-page");
            $lightbox.find(".slides").remove();
            $lightbox.css({
                paddingLeft: global,
                paddingRight: global,
            });
            $lightbox.remove();
            $("html").removeClass("scroll-locked");
            $slides.toggleClass("fade-in");
        }

        function getPadding($slides) {
            var $cloneSlides = $slides.find(".slide-wrapper");
            var $first = $cloneSlides.first();
            var $last = $cloneSlides.last();
            var firstRatio = $first.width() / $first.height();
            var lastRatio = $last.width() / $last.height();
            var factor = 5 * columnWidth + 4 * columnSpace;

            return {
                left: (window.innerWidth - firstRatio * factor) / 2,
                right: (window.innerWidth - lastRatio * factor) / 2,
            };
        }

        $button.on("click", function () {
            $instance = $(this).parents(selector);
            $slides = $instance.find(".slides");
            var $clone = $slides.clone();

            max = $slides.children().length - 1;

            var headlineContent = $instance.find(".headline").html();
            var descriptionContent = $instance.find(".description").html();
            var theme = $instance.parents("[data-theme]").data("theme");
            var initialRect = $slides[0].getBoundingClientRect();
            var initialOffset = getInitialOffset(initialRect);
            var padding = getPadding($slides);

            $descriptionBox.find(".headline").html(headlineContent);
            $descriptionBox.find(".description").html(descriptionContent);
            $clone.css("transform", `translate(${initialOffset.x}, ${initialOffset.y})`);
            $("html").addClass("scroll-locked");
            $clone.addClass("transition-lg");
            $lightbox.attr("data-theme", theme);
            $lightbox.append($descriptionBox);
            $lightbox.append($clone);
            $("body").append($lightbox);

            setTimeout(function () {
                $slides.toggleClass("fade-in");
                $lightbox.toggleClass("bg-none bg-page");
                $clone.css("transform", "none").toggleClass("no-shrink");
                $clone.find("figure").css("rotate", null).toggleClass("height-3col height-5col");
                $clone.find(".slide-wrapper").toggleClass("no-shrink transition-lg");
                $clone.toggleClass("sx-global");
                $descriptionBox.addClass("on");
                $(window).trigger("contentLoaded");
                $lightbox.css({
                    paddingLeft: isMobile ? global : padding.left,
                    paddingRight: isMobile ? global : padding.right,
                });
                setTimeout(function () {
                    $clone.find("figcaption").toggleClass("on");
                }, delay);
            }, 0);

            $minimizeButton.on("click", function () {
                $descriptionBox.toggleClass("left-0.5 sm:left-1.0 md:left-auto md:width-4col md:width-auto");
                $descriptionBox.find(".toolbar").toggleClass("mt-0.5");
                $(this).find("svg").toggleClass("fade-in");
                $context.toggleClass("none");
            });

            $closeButton.on("click", closeHandler);

            $navButton.on("click", function () {
                switch (index) {
                    case 0:
                        index = $(this).is("[data-next]") ? index + 1 : max;
                        break;
                    case max:
                        index = $(this).is("[data-next]") ? 0 : index - 1;
                        break;
                    default:
                        index = $(this).is("[data-next]") ? index + 1 : index - 1;
                }

                $clone.children().eq(index)[0].scrollIntoView({
                    block: "center",
                    inline: "center",
                });
            });
        });

        $(window).on("escKey", closeHandler);
    }

    $(document).ready(init);
})();
